export default class ApportionHelper {
  static average(list=[]){
    let count=list.length;
    return list.map(ret=>{
      if(!ret.total) ret.total=count;
      if(!ret.id) ret.value=1;
      ret.proportion=ret.value/ret.total;
      return ret;
    })
  }

  static area(list=[]){
    let area_arr=list.map(ret=>ret.area*1)
    let sum = area_arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    return list.map(ret=>{
      if(!ret.total) ret.total=sum;
      if(!ret.id) ret.value=(ret.area*1);
      ret.proportion=ret.value/ret.total;
      return ret;
    })
  }

  static usage(list=[]){
    return list.map(ret=>{
      ret.total=0;
      ret.value=0;
      ret.proportion=0;
      return ret;
    })
  }

  static floor(list=[]){
    let floor_arr=list.map(ret=>ret.floor*1)
    let sum = floor_arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    return list.map(ret=>{
      if(!ret.total) ret.total=sum;
      if(!ret.id) ret.value=(ret.floor*1);
      ret.proportion=ret.value/ret.total;
      return ret;
    })
  }

  static floor2(list=[]){
    let floor_arr=list.map(ret=>(ret.ratio_value||0)*1)
    let sum = floor_arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    return list.map(ret=>{
      ret.total=sum;
      if(ret.selected){
        ret.value=((ret.ratio_value||0)*1);
        ret.selected=undefined;
      }
      ret.proportion=(ret.value||0)/ret.total;
      return ret;
    })
  }

  static currency(list=[]){
    return list.map(ret=>{
      ret.total=0;
      ret.value=0;
      ret.proportion=0;
      return ret;
    })
  }

  static compute(list,config){
    if(config.type==='ratio1'){
      return ApportionHelper.computeRatio1(list,config.data);
    }else {
      return ApportionHelper.computeRatio2(list,config.data);
    }
  }

  static computeRatio1(list=[],config={}){
    let _list=[];
    list.map(ret=>{
      if(ret.floor>=config.start_floor&&ret.floor<=config.end_floor){
        if(ret.floor>=config.start_use_floor){
          ret.ratio_value=Math.ceil(((ret.floor-config.start_use_floor)+1)/config.floor_ratio)*config.ratio
        }else {
          ret.ratio_value=config.ratio
        }
        ret.selected=true;
      }
      _list.push(ret);
    })
    return _list;
  }

  static computeRatio2(list=[],config=[]){
    let _list=[];
    list.map(ret=>{
      config.map(cof=>{
        if(ret.floor>=cof.start_floor&&ret.floor<=cof.end_floor){
          ret.ratio_value=(cof.ratio || 0)*1
          ret.selected=true;
        }
      })
      _list.push(ret);
    })
    return _list;
  }

  static reCompute(list=[]){
    let value_arr=list.map(ret=>ret.value*1)
    let sum = value_arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    return list.map(ret=>{
      ret.total=sum;
      ret.value=(ret.value*1);
      ret.proportion=ret.value/ret.total;
      return ret;
    })
  }

  static reProportion(list=[]){
    return list.map(ret=>{
      ret.proportion=ret.value/ret.total;
      return ret;
    })
  }

  static deleteHouse(list=[],house_ids=[]){
    house_ids.map(house_id=>{
      let index=list.findIndex(item=>item.house_id===house_id);
      if(index!==-1){
        list.splice(index,1)
      }
    });
    return ApportionHelper.reCompute(list);
  }

  static setSelectHouseRatioValue(list=[],house_ids=[],value=0){
    house_ids.map(house_id=>{
      let index=list.findIndex(item=>item.house_id===house_id);
      if(index!==-1){
        list[index].value=value;
      }
    });
    return ApportionHelper.reCompute(list);
  }

  static setSelectHouseItem(list=[],house_ids=[],name="",value=0){
    house_ids.map(house_id=>{
      let index=list.findIndex(item=>item.house_id===house_id);
      if(index!==-1){
        list[index][name]=value;
      }
    });
    return list;
  }

  static whereList(list=[],where){
    return list.filter(ret=>{
      let boole=[];
      if(where.house_name!==''){
        boole.push(ret.house_name.indexOf(where.house_name)!==-1)
      }
      if(where.customer_name!==''){
        boole.push(ret.customer_name.indexOf(where.customer_name)!==-1)
      }
      if(where.floor!==''){
        boole.push(ret.floor==where.floor)
      }
      return boole.filter(ret=>ret===false).length===0;
    })
  }

  static whereUpdate(list=[],where,name,value){
    return list.map(ret=>{
      let boole=[];
      if(where.house_name!==''){
        boole.push(ret.house_name.indexOf(where.house_name)!==-1)
      }
      if(where.customer_name!==''){
        boole.push(ret.customer_name.indexOf(where.customer_name)!==-1)
      }
      if(where.floor!==''){
        boole.push(ret.floor==where.floor)
      }
      if(boole.filter(ret=>ret===false).length===0){
        ret[name]=value;
      }
      return ret;
    })
  }
  static allUpdate(list=[],name,value){
    return list.map(ret=>{
      ret[name]=value;
      return ret;
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/EnergyConsumption/components/meter/components/apportion/common/ApportionHelper.js